import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'card mb-12',
})`
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: none;

    > p {
      margin-bottom: 0;
    }
    .close {
      font-size: 20px;
      color: white;
    }
  }
  .card-body {
    width: 100%;
    height: 100%;
    flex: 1;
    border: none;

    display: flex;
    align-items: center;

    > label {
      width: 230px;
    }

    > button {
      margin-left: 10px;
      width: 200px;
      svg {
        margin-right: 5px;
      }
    }
  }
`;
